<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back" />
			<img src="@/images/center_text10.png" class="per_right_1name" />
		</div>
		<div class="per_right_2">
			<div class="task_right_bottom">
				<div class="course-info-main clearfix ">
					<div v-for="(item,index) in qusetionlist">
						<div :class="(item.topicType == 1||item.topicType == 3)?'table-wrap single':'table-wrap'">
							<div class="questionTitle">
								{{index+1}}、
								<span v-if="item.topicType == 4">
									{{item.question | spliceQuestion}}
								</span>
								<span v-if="item.topicType != 4">
									{{item.question}}
								</span> <span class="maincolor">（<span v-if="item.topicType == 1">单选题</span>
								<span v-if="item.topicType == 2">多选题</span>
								<span v-if="item.topicType == 3">判断题</span>
								<span v-if="item.topicType == 4">填空题</span>
								<span v-if="item.topicType == 5">简答题</span>）</span>
								<div v-if="item.isFile == '1'" class="filebox" style="margin: 20px 0 0 0;">
									<div class="fileboxname">图片/视频：</div>
									<div>
										<span :key='file.id' v-for="(file,fileindex) in item.files">
									<video style="width: 150px; height: 150px" :src="baseurl + file.url" v-if="file.url.indexOf('.mp4')>-1" controls="controls" muted="muted"></video>
									<el-image fit="fill" style="width: 150px; height: 150px" :src="baseurl + file.url" :preview-src-list="[baseurl + file.url]" v-else>
									</el-image>
									</span>
									</div>
								</div>
							</div>
							<div v-if="item.topicType == 1">
								<div class="questionAnswers" v-for="(it,i) in item.answerlist">
									<div :class="'questionLabel questionLabel'+ item.chooseRight">
										<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
											<div class="inCircle"></div>
										</div>
									</div>
									<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
									<span v-if="it.type == '2'">
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
										</span>
									</span>
								</div>
							</div>
							<div v-if="item.topicType == 2">
								<div class="questionAnswers" v-for="(it,i) in item.answerlist">
									<div :class="'questionLabel questionLabel'+ item.chooseRight">
										<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
											<div class="inCircle"></div>
										</div>
									</div>
									<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
									<span v-if="it.type == '2'">
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
											
										</span>
									</span>
								</div>
							</div>
							<div v-if="item.topicType == 3">
								<div class="questionAnswers" v-for="(it,i) in item.answerlist">
									<div :class="'questionLabel questionLabel'+ item.chooseRight">
										<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
											<div class="inCircle"></div>
										</div>
									</div>
									<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
									<span v-if="it.type == '2'">
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
										</span>
									</span>
								</div>
							</div>
							<div class="questionFooter" v-if="item.topicType == 1 || item.topicType == 2 || item.topicType == 3">
								我的答案：{{item.userAnswer}}&nbsp;&nbsp;
								<i class="iconfont iconcuo" v-if="item.chooseRight == '0'" style="color: #F56C6C;"></i>
								<i class="iconfont icondui" v-if="item.chooseRight == '1'" style="color: #00B43C;"></i>
							</div>
							<div class="questionFooter" v-if="item.topicType == 4">
								我的答案：{{item.userAnswer}}
							</div>
							<div class="questionFooter" v-if="item.topicType == 5">
								<div v-html="getAnswer(item)"></div>
							</div>
							<div class="fileArrbox" v-if="item.userAnswerFilearr && item.userAnswerFilearr.length>0">
								<div class="uploadFile" @click.stop="formPreview(file)" v-for="(file,index) in item.userAnswerFilearr">
									<img src="@/images/word.png" />
									<div class="p1">
										{{file.name}}
									</div>
									<div class="p2">
										{{file.size | filesize}}
									</div>
								</div>
								<div style="clear: both;"></div>
							</div>
							<div class="questionFooter" v-if="item.topicType == 4">
								参考答案：<span v-for="(it,i) in item.answerlist">{{it.value}}&nbsp;&nbsp;</span>
							</div>
							<div class="questionFooter" v-if="item.topicType != 4">
								参考答案：{{item.answer}}
							</div>
							<div class="questionFooter" v-if="item.topicType == 5">
								关键词：<span v-for="(it,i) in item.answerlist">{{it.value}}&nbsp;&nbsp;</span>
							</div>
							<div class="questionFooter">
								解析：{{item.analysis }}
							</div>
							<div class="questionFooter" v-show='item.comment'>
								教师评语：{{item.comment }}
							</div>
						</div>
					</div>
				</div>
				<div class="table-page">
					<el-pagination background @current-change="askPageChange" :current-page="askPage" :page-size="pageSize" layout="  prev, pager, next" :total="asktotalRow">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :title="viewName==''?'预览':viewName" :visible.sync="viewShow" append-to-body>
			<div class="viewIframe" v-if="viewShow" v-loading="viewShowLoading">
				<iframe :src="playUrl" v-if="!viewAideoShow"  @load="viewShowLoading = false"></iframe>
				<audio :src="playUrl" v-if="viewAideoShow" controls="controls"></audio>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="viewShow = false">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { downloadFile } from "@/utils/oss.js"
	import { courseAskAnswers } from '@/api/course.js'
	export default {
		data() {
			return {
				pageSize: 10,
				askPage: 1,
				asktotalRow: 0,
				qusetionlist: [],
				//文件
				playUrl: '',
				viewName: '',
				viewShowLoading: true,
				viewShow: false,
				viewAideoShow: false,
				viewopen: window.config.VUE_PDF_FILE,
			};
		},
		created() {
			this.getList();
		},
		methods: {
			getAnswer(item) {
				if(item.userAnswer) {
					var answerlist = item.answerlist;
					var answerStr = '我的答案：';
					var userAnswer = item.userAnswer;
					answerlist.map(answer => {
						userAnswer = userAnswer.split(answer.value).join('<span style="color: #e64242;">' + answer.value + '</span>');
					})
					return answerStr + userAnswer;
				} else {
					return '';
				}
			},
			formPreview(file) {
				var url = file.url;
				var fileUrl = url;
				var fileName = file.name;
				var filetype = file.url.substring(file.url.lastIndexOf('.') + 1);
				this.viewAideoShow = false;
				if(filetype == 'doc' || filetype == 'docx') {
					var playUrl = this.baseurl + url;
					playUrl = this.viewopen + encodeURIComponent(window.btoa(playUrl));
					this.playUrl = playUrl;
					this.viewName = file.name;
					this.viewShow = true;
					this.viewShowLoading = true;
				} else {
					var playUrl = this.baseurl + url;
					this.playUrl = playUrl;
					this.viewName = file.name;
					this.viewShow = true;
					if(filetype == 'mp3' || filetype == 'wav') {
						this.viewAideoShow = true;
					}
				}
			},
			askPageChange(page) {
				this.askPage = page;
				this.getList()
			},
			getList() {
				var data = {
					pageSize: this.pageSize,
					page: this.askPage
				}
				courseAskAnswers(data).then(res => {
					if(res.code == 0) {
						this.asktotalRow = res.data.totalRow;
						var qusetionlist = [];
						res.data.listData.map(item => {
							var qusetion = item.askTopic;
							qusetion.userAnswer = item.userAnswer
							qusetionlist.push(qusetion)
						})
						this.qusetionlist = qusetionlist;
						this.formInit()
					}
				})
			},
			formInit() {
				var qusetionlist = this.qusetionlist;
				qusetionlist.map(item => {
					item.over = false;
					if(item.topicType != 4 && item.topicType != 5) {
						if(!item.userAnswer) {
							item.choose = [];
						} else {
							item.choose = item.userAnswer.split('')
						}

						if(item.userAnswer && item.userAnswer == item.answer) {
							item.chooseRight = 1
						} else {
							item.chooseRight = 0
						}
					}
					if(item.topicType == 5 && item.userAnswerFile && item.userAnswerFile != '') {
						item.userAnswerFilearr = JSON.parse(item.userAnswerFile);
						item.userAnswerFile = item.userAnswerFile;
					}
					if(item.isFile == 1 && item.fileName != null) {
						var files = JSON.parse(item.fileName);
						item.files = files;
						var openfiles = [];
						files.map(item => {
							var openurl = this.baseurl + item.url;
							openfiles.push(openurl)
						})
						item.openfiles = openfiles;
					}
					if(item.topicType == 5 && item.userAnswerFile && item.userAnswerFile != '') {
						item.userAnswerFilearr = JSON.parse(item.userAnswerFile);
						item.userAnswerFile = item.userAnswerFile;
					}
					var answerlist = [];
					if(item.optionA != '' && item.optionA != null) {
						if(item.optionA.indexOf('@') == -1) {
							answerlist[0] = {
								type: '1',
								label: 'A',
								value: item.optionA,
							}
						} else {
							answerlist[0] = {
								type: '2',
								label: 'A',
								value: item.optionA.slice(1),
							}
						}
					}
					if(item.optionB != '' && item.optionB != null) {
						if(item.optionB.indexOf('@') == -1) {
							answerlist[1] = {
								type: '1',
								label: 'B',
								value: item.optionB,
							}
						} else {
							answerlist[1] = {
								type: '2',
								label: 'B',
								value: item.optionB.slice(1),
							}
						}
					}
					if(item.optionC != '' && item.optionC != null) {
						if(item.optionC.indexOf('@') == -1) {
							answerlist[2] = {
								type: '1',
								label: 'C',
								value: item.optionC,
							}
						} else {
							answerlist[2] = {
								type: '2',
								label: 'C',
								value: item.optionC.slice(1),
							}
						}
					}
					if(item.optionD != '' && item.optionD != null) {
						if(item.optionD.indexOf('@') == -1) {
							answerlist[3] = {
								type: '1',
								label: 'D',
								value: item.optionD,
							}
						} else {
							answerlist[3] = {
								type: '2',
								label: 'D',
								value: item.optionD.slice(1),
							}
						}
					}
					if(item.optionE != '' && item.optionE != null) {
						if(item.optionE.indexOf('@') == -1) {
							answerlist[4] = {
								type: '1',
								label: 'E',
								value: item.optionE,
							}
						} else {
							answerlist[4] = {
								type: '2',
								label: 'E',
								value: item.optionE.slice(1),
							}
						}
					}
					if(item.optionF != '' && item.optionF != null) {
						if(item.optionF.indexOf('@') == -1) {
							answerlist[5] = {
								type: '1',
								label: 'F',
								value: item.optionF,
							}
						} else {
							answerlist[5] = {
								type: '2',
								label: 'F',
								value: item.optionF.slice(1),
							}
						}
					}
					item.answerlist = answerlist;
				})
				this.qusetionlist = qusetionlist;
				this.loading = false;
			},
		},
	};
</script>